var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.6775C5.8795 6.6775 5.76734 6.65825 5.6635 6.61975C5.55967 6.58125 5.46092 6.51525 5.36725 6.42175L0.873002 1.9275C0.734669 1.789 0.663835 1.61492 0.660502 1.40525C0.657335 1.19575 0.728169 1.0185 0.873002 0.8735C1.018 0.728667 1.19367 0.65625 1.4 0.65625C1.60634 0.65625 1.782 0.728667 1.927 0.8735L6 4.94675L10.073 0.8735C10.2115 0.735167 10.3856 0.664333 10.5953 0.661C10.8048 0.657833 10.982 0.728667 11.127 0.8735C11.2718 1.0185 11.3443 1.19417 11.3443 1.4005C11.3443 1.60683 11.2718 1.7825 11.127 1.9275L6.63275 6.42175C6.53909 6.51525 6.44033 6.58125 6.3365 6.61975C6.23267 6.65825 6.1205 6.6775 6 6.6775Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f7192107c16ad7d8194da5e245027271.svg";
export { ForwardRef as ReactComponent };